export default __webpack_public_path__ + "static/media/ret4.e3e4df23.jpeg";